export enum OperatorsEnum {
    SUPERIOR = 'SUPERIOR',
    SUPERIOR_EQUAL = 'SUPERIOR_EQUAL',
    INFERIOR = 'INFERIOR',
    INFERIOR_EQUAL = 'INFERIOR_EQUAL',
    EQUAL = 'EQUAL',
}

export default OperatorsEnum;
